import React from "react";
import PropTypes from "prop-types";
import classes from "./styles.module.scss";

const NotificationCard = ({ notify_header, old_new_status, send_by, notification_time, notification_text }) => {
    return (
        <div className={classes.notification_card}>
            <div className={classes.notify_header}>
                <p className={classes.header_head}>{notify_header}</p>
                {old_new_status && (
                    <p className={classes.old_new_status}>{old_new_status}</p>
                )}
            </div>
            <p className={classes.notification_text}>
                {notification_text}
            </p>
            <div className={classes.notify_footer}>
                <p className={classes.by_whom}>{send_by}</p>
                <p className={classes.time}>{notification_time}</p>
            </div>
        </div>
    );
};

NotificationCard.propTypes = {
    notify_header: PropTypes.string.isRequired,
    old_new_status: PropTypes.string,
    send_by: PropTypes.string,
    notification_time: PropTypes.string,
    notification_text: PropTypes.string,
};

export default NotificationCard;